.zhzn8w0 {
  --default-handle-shadow: 0px 0px 1px rgba(0, 0, 0, 1);
  --divider-shadow: 0px 0px 1px rgba(0, 0, 0, 0.5);
  outline: none;
}
.zhzn8w1 {
  width: 100%;
  object-fit: contain;
  background-color: var(--pluma-color-surface-base);
}
.zhzn8w2 {
  position: relative;
}
.zhzn8w3 {
  background: var(--pluma-color-surface-base);
  border: var(--pluma-border-width-0125) solid var(--pluma-color-border-base);
  color: var(--pluma-color-text-base);
  line-height: 100%;
  border-radius: var(--pluma-radius-6);
  opacity: 0.8;
  position: absolute;
  padding: var(--pluma-space-100);
}
.zhzn8w4 {
  top: var(--pluma-space-100);
}
.zhzn8w5 {
  bottom: var(--pluma-space-100);
}
.zhzn8w6 {
  left: var(--pluma-space-100);
}
.zhzn8w7 {
  right: var(--pluma-space-100);
}